import React, { useState } from 'react';
import Accordion from '../../Components/Accordion/Accordion';
import Heading from '../../Components/Heading/Heading';
import './style.scss';


const Competences = () => {
  // je fais un tableau des langages et technologies
  const [langagesTechnologies] = useState([
    // "skills/nextjs.svg",
    "skills/react.svg",
    "skills/js.svg",
    "skills/html.svg",
    "skills/css.svg",
    // "skills/framer-motion.svg",
    "skills/nodejs.svg",
    "skills/express.svg",
    // "skills/python.svg",
    "skills/bootstrap.svg",
    // "skills/git.svg",
    "skills/github.svg",
    "skills/mongodb.svg",
    // "skills/tailwind.svg",
    // "skills/linux.svg",
  ]);
  const [accordeonOuvert, setAccordeonOuvert] = useState(false);

  const toggleAccordeon = () => {
    setAccordeonOuvert(!accordeonOuvert);
  };


  // mes expériences
  const [experiences] = useState([
    { id: 1, titre: 'Développeur Web', entreprise: 'PrepaAvenir' },
    { id: 2, titre: 'Stage en Développement', entreprise: 'Atos à Bezons' },
  ]);

  // les compétences hors informatique
  const [autresCompetences] = useState([
    'Communication',
    'Gestion de projet',
    'Rédaction',
  ]);

  //  les hobbies
  const [hobbies] = useState(['Voyages', 'Football', 'cinema']);

  return (
    <div>
      <Heading firstWord="Mes" secondWord="Competences" />
      <div className="container_competences">
        {/* <h1>Compétences</h1> */}

        <div className="langages-section">
        <h2>Langages et Technologies:</h2>
{/* <Accordion  content={  <ul className="svg-grid">
    {langagesTechnologies.map((item, index) => (
      <li key={index}><img src={item} alt="" /></li>
    ))}
  </ul>}> */}
      <Accordion 
      titre='Langages et Technologies:' 
      content={
        <ul className={`svg-grid ${accordeonOuvert ? 'open' : ''}`}>
          {langagesTechnologies.map((item, index) => (
            <li key={index}><img src={item} alt="" /></li>
          ))}
        </ul>
      }
      onToggle={toggleAccordeon}
    >

</Accordion>

        </div>

        <divb className="experiences-section">
          <h2>Expériences:</h2>
<Accordion  content={<ul>
            {experiences.map((exp) => (
              <li key={exp.id}>
                {exp.titre} chez {exp.entreprise}
              </li>
            ))}
          </ul>}>
          
          </Accordion>
        </divb>

        <div className="autres-competences-section">
          <h2>Autres Compétences:</h2>
          <Accordion  content={          <ul>
            {autresCompetences.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>}>
           </Accordion>

        </div>

        <div className="hobbies-section">
          <h2>Hobbies:</h2>
          <Accordion  content={      <ul>
            {hobbies.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
              }>
           </Accordion>
        
        </div>
      </div>
    </div>
  );
};

export default Competences;
